/*
  Proben-Upsell im Warenkorb (Theme-Kopie "Proben-Upsell Namos", 11.09.2026)
  Markup: snippets/fragrens-proben-upsell.liquid

  Legt eine Probe in den Warenkorb, ohne die Seite neu zu laden, und nimmt dafuer
  denselben Weg wie das Theme beim Mengenaendern:
  - Wer neu gerendert werden will, meldet sich auf "cart:prepare-bundled-sections"
    (der Drawer tut das selbst). Shopify liefert diese Sections in der Antwort von
    /cart/add.js mit, danach geht "cart:change" raus. Die alten Upsell-Bloecke feuern
    "cart:refresh" und laden den Drawer dadurch ein zweites Mal.
  - Auf der Warenkorbseite kommt main-cart in derselben Antwort mit und ersetzt
    sich an Ort und Stelle. Das Theme selbst laedt dort die ganze Seite neu.

  Die angetippte Kachel bleibt unter dem Finger stehen, obwohl oben eine Zeile
  dazukommt, und behaelt den Fokus.

  Am Ende: der Versandbalken im Drawer waechst nach jeder Aenderung sichtbar nach.
*/
(() => {
  if (window.fragrensProbenUpsell) return;
  window.fragrensProbenUpsell = true;

  const root = window.Shopify?.routes?.root || '/';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const pending = new Set();
  let queue = Promise.resolve();

  const MESSAGES = {
    unavailable: 'Diese Probe ist gerade nicht verfügbar.',
    failed: 'Das hat nicht geklappt. Bitte versuch es noch einmal.'
  };

  const liveRegion = document.createElement('div');
  liveRegion.className = 'sr-only';
  liveRegion.setAttribute('aria-live', 'polite');
  document.body.append(liveRegion);

  const findCard = (context, variantId) =>
    document.querySelector(`[data-proben-context="${context}"] [data-proben-variant="${variantId}"]`);

  const findModule = (context) => document.querySelector(`[data-proben-context="${context}"]`);

  const setBusy = (card, busy) => {
    if (!card) return;
    if (busy) card.setAttribute('aria-busy', 'true');
    else card.removeAttribute('aria-busy');
  };

  // Nach jedem Neurendern: Proben, deren Anfrage noch laeuft, wieder als "laeuft" zeigen.
  const syncBusy = () => {
    pending.forEach((variantId) => {
      document.querySelectorAll(`[data-proben-variant="${variantId}"]`).forEach((card) => setBusy(card, true));
    });
  };

  const showStatus = (context, message) => {
    const status = findModule(context)?.querySelector('.fragrens-proben__status');
    if (!status) return;
    status.textContent = message;
    status.hidden = !message;
  };

  const waitForEvent = (target, name, timeout = 2500) =>
    new Promise((resolve) => {
      if (!target) return resolve();
      const timer = setTimeout(resolve, timeout);
      target.addEventListener(name, () => {
        clearTimeout(timer);
        resolve();
      }, { once: true });
    });

  const scroller = (context) =>
    context === 'drawer' ? document.querySelector('cart-drawer')?.shadowRoot?.querySelector('[part="body"]') : null;

  const replaceSection = (sectionId, html) => {
    const current = document.getElementById(`shopify-section-${sectionId}`);
    const fresh = html && new DOMParser().parseFromString(html, 'text/html').getElementById(`shopify-section-${sectionId}`);
    if (!current || !fresh) return false;

    // createContextualFragment statt innerHTML, damit Inline-Skripte der Section wieder laufen.
    current.replaceChildren(document.createRange().createContextualFragment(fresh.innerHTML));
    return true;
  };

  const addProbe = async ({ variantId, context, sectionId, title, hadFocus, tag, added }) => {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
    if (context === 'page' && sectionId && !sections.includes(sectionId)) sections.push(sectionId);

    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    let response;
    let json;
    try {
      response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1, properties: { _upsell: tag || 'warenkorb-namos-proben' } }],
          sections: sections.join(','),
          sections_url: window.location.pathname
        })
      });
      json = await response.json();
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    }

    if (!response.ok) {
      const error = new Error(json?.description || 'add failed');
      error.status = response.status;
      throw error;
    }

    // Ab hier liegt die Probe im Warenkorb. Nicht mehr als "laeuft" markieren,
    // sonst zeigt die neu gerenderte Kachel kurz Spinner und Haekchen zugleich.
    pending.delete(variantId);

    const cart = await (await fetch(`${root}cart.js`)).json();
    cart.sections = json.sections;

    const anchorTop = findCard(context, variantId)?.getBoundingClientRect().top;
    const drawer = document.querySelector('cart-drawer');
    const drawerRefreshed = context === 'drawer' ? waitForEvent(drawer, 'cart-drawer:refreshed') : null;

    if (context === 'page' && !replaceSection(sectionId, json.sections?.[sectionId])) {
      window.location.reload();
      return;
    }

    if (json.sections) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'line-item:change', cart }
      }));
    } else {
      // Ohne mitgelieferte Sections holt sich der Drawer seinen Stand selbst.
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }

    if (drawerRefreshed) await drawerRefreshed;

    liveRegion.textContent = `${title}, ${added || '3-ml-Probe liegt im Warenkorb.'}`;

    const card = findCard(context, variantId);
    if (!card) return; // letzte offene Probe: der Block ist weg

    if (anchorTop !== undefined) {
      const delta = card.getBoundingClientRect().top - anchorTop;
      if (Math.abs(delta) > 1) {
        const area = scroller(context);
        if (area) area.scrollTop += delta;
        else window.scrollBy(0, delta);
      }
    }

    if (hadFocus) card.focus({ preventScroll: true });

    if (!reducedMotion.matches) {
      card.querySelector('.fragrens-proben__badge')?.animate(
        [{ transform: 'scale(0.82)' }, { transform: 'scale(1)' }],
        { duration: 260, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' }
      );
    }
  };

  document.addEventListener('click', (event) => {
    const card = event.target.closest('[data-proben-variant]');
    if (!card) return;

    const module = card.closest('[data-proben]');
    const variantId = card.dataset.probenVariant;
    if (!module || card.getAttribute('aria-disabled') === 'true' || pending.has(variantId)) return;

    const job = {
      variantId,
      context: module.dataset.probenContext,
      sectionId: module.dataset.sectionId,
      title: card.dataset.probenTitle,
      hadFocus: document.activeElement === card,
      tag: module.dataset.probenTag,
      added: module.dataset.probenAdded
    };

    pending.add(variantId);
    setBusy(card, true);
    showStatus(job.context, '');

    // Nacheinander, nie parallel: jede Antwort rendert den Warenkorb komplett neu.
    queue = queue
      .then(() => addProbe(job))
      .catch((error) => {
        showStatus(job.context, error.status === 422 ? MESSAGES.unavailable : MESSAGES.failed);
      })
      .finally(() => {
        pending.delete(variantId);
        document.querySelectorAll(`[data-proben-variant="${variantId}"]`).forEach((el) => setBusy(el, false));
        syncBusy();
      });
  });

  document.addEventListener('cart-drawer:refreshed', syncBusy);

  /*
    Versandbalken (snippets/fragrens-free-shipping-bar.liquid): der Drawer wird bei jeder
    Aenderung neu gerendert, der neue Balken steht sofort auf dem Endwert. Damit man sieht,
    was die Probe oder der Flakon gebracht hat, waechst er vom letzten Stand aus nach.
  */
  const fsbValue = () => {
    const fsb = document.querySelector('.cart-drawer .fragrens-fsb');
    return fsb ? parseFloat(fsb.dataset.fsbProgress) : null;
  };
  const fsbClip = (progress) => `inset(0 ${(100 - progress * 100).toFixed(2)}% 0 0 round 999px)`;
  let fsbLast = fsbValue();

  document.addEventListener('cart-drawer:refreshed', () => {
    const fsb = document.querySelector('.cart-drawer .fragrens-fsb');
    const next = fsbValue();
    const from = fsbLast ?? 0; // leerer Warenkorb vorher: von null an wachsen
    fsbLast = next;
    if (!fsb || next === null || next === from || reducedMotion.matches) return;

    fsb.querySelector('.fragrens-fsb__meter-fill')?.animate(
      [{ clipPath: fsbClip(from) }, { clipPath: fsbClip(next) }],
      { duration: 650, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' }
    );

    if (next >= 1 && from < 1) {
      fsb.querySelector('.fragrens-fsb__check')?.animate(
        [{ transform: 'scale(0.6)', opacity: 0 }, { transform: 'scale(1)', opacity: 1 }],
        { duration: 280, delay: 380, easing: 'cubic-bezier(0.23, 1, 0.32, 1)', fill: 'backwards' }
      );
    }
  });
})();
